<template>
<v-row justify="center">
  <v-dialog v-model="DetailGroupDialog" persistent max-width="290" style="overflow: hidden !important;">
    <v-card :style="stylechat">
      <v-card-title class="pa-3">
        <v-spacer></v-spacer>
        <v-icon class="color-btn pr-2" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-row justify="center" align="center">
          <v-col cols="12" justify="center" align="center">
            <v-avatar
              size="60"
            >
            <img v-if="InforGroup.picture" :src="InforGroup.picture" alt="" class="img-position">
            <img v-else :src="`${publicPath}/assets/img/default_profile/group-white.png`" alt="" class="img-position">
            </v-avatar>
          </v-col>
          <v-col cols="12" justify="center" align="center">
            <p class="font-title text-overflow">{{InforGroup.name}}</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-flex xs6 md6 sm6>
          <v-btn text block class="color-btn" @click="toPage(InforGroup.group_id)">
            <v-icon class="color-btn pr-2">mdi-account-multiple</v-icon>
            {{$t('Dialog.profilefriend.headerProfile')}}
          </v-btn>
        </v-flex>
        <v-flex xs6 md6 sm6 :loading="loading" @click="checkState(InforGroup.state)">
          <v-btn text block class="color-btn">
            <v-icon class="color-btn pr-2">{{icon}}</v-icon>
            {{text_btn}}
          </v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
    <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
  </v-dialog>
</v-row>
</template>
<script>
import { sync } from 'vuex-pathify'
import ErrorDialog from '@/components/Alert/Error'

export default {
  props: {
    DetailGroupDialog: Boolean,
    InforGroup: {}
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_BASE_PATH,
      ErrorDialogDetail: {},
      ErrorDialog: false,
      icon: '',
      text_btn: '',
      stylechat: {
        "--DetailGroup-HeaderColor": "white",
        "--DetailGroup-TabBackground": "white",
        "--DetailGroup-Icon": "gray",
        "--DetailGroup-IconActive": "#2662ae",
        "--DetailGroup-Background": "white",
        "--DetailGroup-FontSize": "18px",
        "--DetailGroup-FontColor": "black",
        "--DetailGroup-FontSize-Status": "16px",
        "--DetailGroup-FontColor-Status": "grey",
        "--DetailGroup-Background-Input": "#E2E1E3",
        "--DetailGroup-Color-Button": "#EFF2FE",
        "--DetailGroup-FontColor-Button": "#2662ae"
      },
      data_user: {},
      loading: false,
    }
  },
  computed: {
    ...sync('*')
  },
  components: {
    ErrorDialog
  },
  watch: {
    DetailGroupDialog() {
      // console.log(this.InforGroup)
      if (this.DetailGroupDialog) {
        if (this.InforGroup.state === 'group' || this.InforGroup.state === 'active') {
          this.text_btn = this.$t('AnswerQuestion.chat')
          this.icon = 'fa-solid fa-comment-dots'
        } else if (this.InforGroup.state === 'pending') {
          this.text_btn = this.$t('AnswerQuestion.joinGroup')
          this.icon = 'mdi-account-plus'
        } else {
          this.text_btn = this.$t('AnswerQuestion.chat')
          this.icon = 'fa-solid fa-comment-dots'
        }
      }
    }
  },
  created() {
    // console.log('themechat', this.themechat)
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
  },
  methods: {
    toPage (id) {
      this.$cookie.set('select_menu', 2)
      if (this.InforGroup.path !== undefined) {
        this.$router.push(`/web/profilegroup/${id}`)
      } else {
        this.$router.push(`/profile/group/${id}`)
      }
      this.closeDialog()
    },
    closeAlertDialog (item) {
      if (item.type === 'err') {
        this.ErrorDialog = false
      }
    },
    closeDialog() {
      this.$emit('closeDialog', {
        name: 'DetailGroup',
        value: false
      })
    },
    checkState (type) {
      // console.log('type: ', type)
      if (type === 'group' || type === 'active') {
        this.$cookie.set('select_menu', 2)
        // this.$router.push(`/chat/${this.InforGroup.tokenroom}`)
        if (this.InforGroup.path !== undefined) {
          this.$router.push(`${this.InforGroup.path}`)
        } else {
          this.$router.push(`/chat/${this.InforGroup.tokenroom}`)
        }
      } else if (type === 'pending') {
        this.loading = true
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/accept-group`, {
          group_id: this.InforGroup.group_id,
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.loading = false
            this.text_btn = this.$t('AnswerQuestion.chat')
            this.icon = 'fa-solid fa-comment-dots'
            this.InforGroup.tokenroom = response.data['group'][0].tokenroom
            this.InforGroup.state = 'group'
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.loading = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    }
  }
}
</script>
<style lang="css" scoped>
.text-overflow {
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  width: 250px !important;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.font-color-btn {
  color: var(--DetailGroup-FontColor-Button) !important;
}
.font-title {
  color: var(--DetailGroup-FontColor) !important;
  font-weight: 600 !important;
  font-size: var(--DetailGroup-FontSize) !important;
}
.color-btn {
  /* background-color: var(--DetailGroup-Color-Button) !important; */
  color: var(--DetailGroup-IconActive) !important;
  text-transform: none !important;
}
</style>
